export default __webpack_public_path__ + "static/counterfeit_security_upgrade-2921d0c8b2c97a1a97c80355b221ab64.png";